export default __webpack_public_path__ + "static/qualität-c417d0e7dda52f253ba89c9ea276c2f4.svg";